import { useState } from "react";
import BCModal from "../../ui/BCModal";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const CollectionsTable = () => {
  const [isCollectionsDataOpen, setIsCollectionsDataOpen] = useState(false);
  const [checkedCollectionsId] = useState(
    "26942888-ceca-44a3-a7cc-0033e7a51cf4"
  );

  const formActions = ["save", "close"];
  const actionButtons = [
    "save",
    "cancel",
    "export",
    {
      text: "Add Comments",
      isDisabled: (checkedItems: string | any[]) => checkedItems?.length === 0,
      handleClick: () => {
        setIsCollectionsDataOpen(true);
      },
    },
  ];

  const collectionFormFields = (myForm) => {
    myForm.addCenteredGroup([
      myForm.getDropdownField("Borrower", "orgs/list-orgs", { name: "borrowerOrganizationId", required: true }),
      myForm.getDropdownField("Special Purpose Entity", "orgs/list-spes", { dependencyField: "borrowerOrganizationId" }),
    ]);

    myForm.addCenteredGroup([
      myForm.getDisplayField("Application #", { name: "applicationNumber" }),
      myForm.getDisplayField("Loan", { name: "loanNumber" }),
      myForm.getDropdownField("Category", "orgs/list-comment-categories", { name: "commentCategoryId", required: true }),
    ]);

    myForm.addCenteredGroup([
      myForm.getDropdownField("Comment Subject", "", {
        required: true,
      }),

      myForm.getInputField("Comments", {
        name: "description",
        field: "textarea",
        required: true,
      }),
    ]);

    myForm.addCenteredGroup([
      myForm.getCheckboxField("Generate Email?", { name: "generateEmail" }),
    ]);

    return myForm;
  };
  
  const myForm = collectionFormFields(
    new BCFormController({}, { submitSuffix: "", blankWidth: 4 })
  );

  return (
    <>
      {checkedCollectionsId && (
        <BCModal
          isModalOpen={isCollectionsDataOpen}
          size="large"
          closeIcon
          onClose={() => setIsCollectionsDataOpen(false)}
          content={
            <>
              <LmsFormGenerator myForm={myForm} actions={formActions} />
            </>
          }
        />
      )}
      <LmsTable
        actionButtons={actionButtons}
        apiSuffix="report/collection"
        useApiFiltering
      />
    </>
  );
};

const LmsReportsCollections = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <CollectionsTable />;
};

export default LmsReportsCollections;